<template>
<div class="chapter">
<div class="inner_page">
<p class="br"> </p><p class="br"> </p><p class="br"> </p><p class="br"> </p>
<p class="dt"><strong>Ma was propped up with extra pillows.</strong></p>
<p class="br"> </p>
<p class="p1">Her night table was cluttered with various bottled remedies, her little helpers. I could see she had been crying. I suppose she could see I had been too. She patted the bed beside her.</p>
<p>“What a blessing I have you, Poppy,” she said. “If you had been as favored with beauty as Honey you'dy soon make a good match and then what would I do, left all alone in the world?”</p>
<p>I opened my mouth to say I didn't think Honey was all <em>that</em> favored with beauty, but Ma was getting into her stride.</p>
<p>“But it's so clear to me now,” she continued. “I was given a beauty for the consolation her children will bring me, and I was given a plain one for companionship in my old age. How wise Nature is!”</p>
<p>I said, “Does this mean I don't have to go to Cincinnati for a new nose?”</p>
<p>“The nose is canceled,” she said. “And the singing lessons and the French and the cotillions. There's no sense in exerting ourselves in that direction anymore.”</p>
<p>The great husband hunt had been called off.</p>
<p class="fmh1">PRAISE FOR <em>THE GREAT HUSBAND HUNT</em></p>
<p class="fsq">“A delight…Graham's style is riveting, hilarious one-liners falling in quick succession.”</p>
<p class="fsqs">—<em>The Times</em> (London)</p>
<p class="fsq">“Fresh, funny, and smart.”</p>
<p class="fsqs">—<em>Observer</em> (London)</p>
<p class="fsq">“An irrepressible adventurer, Poppy is a comic combination of innocence and pluck, but although this is a brisk, breezy read, it's also a novel with serious bite.”</p>
<p class="fsqs">—<em>Daily Mail</em></p>
<p class="fsq">“A combination of stealthy nostalgia and tender comedy…she writes with pathos—a quality that is rarely taken seriously nowadays, perhaps because it usually relies on a quality of innocence for its effect.”</p>
<p class="fsqs">—<em>Times Literary Supplement</em></p>
<p class="fsq">“It's the insight it offers into changing personal attitudes and family life during this turbulent period that makes it such a fascinating read. The central character is delightful and the characters she encounters are both accurate and colorful.”</p>
<p class="fsqs">—<em>Irish News</em></p>
<p class="fsq">“Compelling…doesn't disappoint.”</p>
<p class="fsqs">—<em>Hello!</em></p>
<p class="fsq">“Laurie Graham is a writer with a remarkably malleable comic voice.”</p>
<p class="fsqs">—<em>Guardian</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GreatHusbandHu_fron-1.vue?2833e725